// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eR2R","top":"styles_top__1MLWL"};